import React from 'react';
import './HeaderImage.scss';
import {Poi} from '../../react-app-env';
import {PoiMetaData} from '../../services/MetaDataService';

export interface HeaderImageProps {
  poi: Poi;
  metaData: PoiMetaData | null;
}

const HeaderImage: React.FunctionComponent<HeaderImageProps> = ({ poi, metaData }) => {
  const thumbnailImage = poi.imageUrl ?? metaData?.thumbnailUrl;
  if (!thumbnailImage) {
    return null;
  }

  return <div className="header-image"
              style={{
                backgroundImage: 'url(' + thumbnailImage + ')'
              }}>
  </div>;
}

export default HeaderImage;
